import React, { useEffect, useState, useRef } from 'react'
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormInput } from './hooks';
import { authenticationService, languageService } from "./services";
import { Toast } from 'primereact/toast';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import './login.scss';
import './index.scss';
import { InputOtp } from 'primereact/inputotp';
import { Dialog } from 'primereact/dialog';

export const Login = (props) => {

    const [isRememberMe, setIsRememberMe] = useState(false);
    const [forgetPassword, changeForgetPassword] = useState(true);
    const [wrongPassword, setWrongPassword] = useState(false);
    const username = useFormInput("");
    const password = useFormInput("");
    const captcha = useFormInput("");
    const [isLoading, setIsLoading] = useState(false);
    const [isResetLoading, setIsResetLoading] = useState(false);
    const [domainList, setDomainList] = useState([]);
    const [language, setLanguage] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    const [selectedDomainName, setSelectedDomainName] = useState(null);
    const toast = useRef(null);
    const [otp, setOtp] = useState(null);
    const [userId, setUserId] = useState(null);
    const [visible, setVisible] = useState(false);
    const [count, setCount] = useState(10);
    const [isCounting, setIsCounting] = useState(false);
    const [captchaId, setCaptchaId] = useState(null);
    const [theme, setTheme] = useState();
    const [backgroundImage, setBackgroundImage] = useState();
    const [logo, setLogo] = useState();
    const [appName, setAppName] = useState();
    const [edevlet, setEdevlet] = useState(false);
    const [register, setRegister] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [captchaControl, setCaptchaControl] = useState(false);
    const [identityNumber, setIdentityNumber] = useState(false);
    const [forgotPassword, setForgotPassword] = useState(false);
    const [domainSelection, setDomainSelection] = useState(false);
    const [changeLanguageControl, setChangeLanguageControl] = useState(false);
    const [version, setVersion] = useState(null);
    const [isOtp, setIsOtp] = useState(null);
    const [retriesCount, setRetriesCount] = useState(0);
    const [counter, setCounter] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        authenticationService.getLoginParameters(props.url).then(response => {
            if (!response.success) {
                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_100'),
                    life: 3000
                });
                return;
            }

            setDomainList(response.data.filter(x => x.key.includes("LdapDomain")));
            setAppName(response.data.find(x => x.key === "app-name")?.value);
            setBackgroundImage(response.data.find(x => x.key === "login-background-image")?.value);
            setLogo(response.data.find(x => x.key === "login-logo")?.value);
            setTheme(response.data.find(x => x.key === "login-theme")?.value);
            setEdevlet(response.data.find(x => x.key === "edevlet")?.value === "true");
            setRegister(response.data.find(x => x.key === "register")?.value === "true");
            setRememberMe(response.data.find(x => x.key === "remember-me")?.value === "true");
            setCaptchaControl(response.data.find(x => x.key === "captcha")?.value === "true");
            setIdentityNumber(response.data.find(x => x.key === "identity-number")?.value === "true");
            setForgotPassword(response.data.find(x => x.key === "forgot-password")?.value === "true");
            setDomainSelection(response.data.find(x => x.key === "domain-selection")?.value === "true");
            setChangeLanguageControl(response.data.find(x => x.key === "change-language")?.value === "true");
            setVersion(response.data.find(x => x.key === "login-version")?.value);
            setIsOtp(response.data.find(x => x.key === "otp-control")?.value === "true");
            setRetriesCount(Number(response.data.find(x => x.key === "retries-count")?.value) || 0);

        }).catch(ex => {

            console.error(ex);
            toast.current.show({
                severity: 'error',
                detail: props.t('err_001_045_100'),
                life: 3000
            });
        }).finally(() => {
            setIsLoading(false);
        });

    }, []);

    useEffect(() => {
        if (!captchaControl)
            props.localStorageUserKey
                ? localStorage.removeItem(props.localStorageUserKey)
                : localStorage.removeItem(appName + "-user");

        if (captchaControl && forgotPassword) {
            generateCaptcha();
        }

        if (rememberMe) {
            const usernameRm = localStorage.getItem(appName + "-username-rm");
            if (usernameRm) {
                username.setValue(usernameRm);
                setIsRememberMe(true);
            }
        }

        document.getElementsByClassName('bs-login')[0].classList.add(theme);

        if (changeLanguageControl) {
            languageService.getLanguages(props.languageManagementUrl)
                .then(response => {
                    if (!response.success) {
                        toast.current.show({
                            severity: 'error',
                            detail: response.message,
                            life: 3000
                        });
                        return;
                    }

                    const languageOptions = response.data.map(item => ({
                        key: item.key,
                        value: item.name
                    }));

                    setLanguage(languageOptions);
                    const langKey = localStorage.getItem(props.languageKey) || 'tr';
                    setSelectedLanguage(langKey);
                })
                .catch(error => {
                    console.error(error);
                    toast.current.show({
                        severity: 'error',
                        detail: "Beklenmeyen bir hata oluştu!",
                        life: 3000
                    });
                });
        }
    }, [
        captchaControl,
        forgotPassword,
        rememberMe,
        theme,
        changeLanguageControl,
        appName,
        props.localStorageUserKey,
        props.languageManagementUrl
    ]);

    useEffect(() => {
        if (!isCounting) return;

        if (count <= 0) {
            setIsCounting(false);
            return;
        }

        const timer = setInterval(() => {
            setCount(prev => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [isCounting, count]);

    useEffect(() => {
        if (wrongPassword)
            generateCaptcha();
    }, [wrongPassword])

    const changeLanguage = (newLang) => {
        localStorage.setItem("bs-core-ozl", newLang);
        setSelectedLanguage(newLang);
        props.i18n.changeLanguage(newLang);
        //window.location.reload();
    };


    const login = async () => {
        const formattedUsername = selectedDomainName ? `${selectedDomainName}/${username.value}` : username.value;

        if (!formattedUsername || !password.value) {
            toast.current.show({
                severity: 'info',
                detail: props.t('info_001_045_098'),
                life: 3000
            });

            //generateCaptcha();
            return;
        }

        if ((captchaControl || wrongPassword)) {
            if (!captcha.value) {
                toast.current.show({
                    severity: 'info',
                    detail: props.t('info_001_045_097'),
                    life: 3000
                });

                //generateCaptcha();
                return;
            } else {
                var validate = await validateCaptcha();

                if (!validate) {
                    toast.current.show({
                        severity: 'info',
                        detail: props.t('info_001_045_096'),
                        life: 3000
                    });

                    generateCaptcha();
                    return;
                }
            }
        }

        if (props.onClick) {
            return props.onClick(formattedUsername, password.value, setIsLoading);
        }

        setIsLoading(true);

        if (props.onRequest) {
            return props.onRequest(formattedUsername, password.value, setIsLoading);
        }

        authenticationService.login(
            {
                username: formattedUsername,
                password: password.value
            },
            props.url
        )
            .then(response => {
                if (props.onPromise) {
                    return props.onPromise(response);
                }

                if (!response.success) {

                    if ((counter + 1) >= retriesCount) {

                        setWrongPassword(true);
                    }

                    setCounter(counter + 1);

                    toast.current.show({
                        severity: response.message == "war_001_045_5069" ? 'warn' : 'error',
                        detail: response.message == "war_001_045_5069" ? props.t('war_001_045_5069') : response.message == "err_001_045_4902" ? props.t('err_001_045_4902') : props.t('err_001_001_001'),
                        life: 3000
                    });

                    generateCaptcha();

                    return;
                }

                if (rememberMe && isRememberMe) {
                    localStorage.setItem(appName + "-username-rm", formattedUsername);
                } else if (rememberMe && !isRememberMe) {
                    localStorage.removeItem(appName + "-username-rm");
                }

                if (isOtp) {
                    setOtp(null);
                    setVisible(true);
                    setCount(250);
                    setIsCounting(true);
                    setUserId(response.data);
                }
                else {
                    if (props.onSuccess) {

                        if (response.data?.user?.isLdapLogin) {
                            props.onSuccess(response.data);
                        } else {

                            if (response.data?.user?.isFirstLogin == false) {
                                props.onSuccess(response.data);
                            } else {
                                const token = response.data?.token; // Backend'in döndüğü token
                                if (token) {
                                    window.location.href = `/reset-password?token=${(token)}`;
                                } else {
                                    console.error(props.t('err_001_045_118'));
                                }
                            }
                        }
                    }
                }
            })
            .catch(ex => {
                console.error(ex);

                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_100'),
                    life: 3000
                });
            })
            .finally(() => {
                setIsLoading(false);

                if (captchaControl) {
                    generateCaptcha();
                }
            });
    };

    const generateCaptcha = () => {
        setIsLoading(true);
        authenticationService.generateCaptcha(
            props.url
        ).then(response => {
            if (!response.success) {
                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_100'),
                    life: 3000
                });
                return;
            }

            setCaptchaId(response.data.captchaId);

            const imageBase64 = response.data.image;

            const imgElement = document.getElementById('bs-captcha-canvas');
            if (imgElement) {
                imgElement.src = `data:image/png;base64,${imageBase64}`;
            }
            captcha.onReset();

        }).catch(ex => {
            toast.current.show({
                severity: 'error',
                detail: props.t('err_001_045_100'),
                life: 3000
            });
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const validateCaptcha = async () => {
        setIsLoading(true);
        try {
            const response = await authenticationService.validateCaptcha(
                {
                    captchaId: captchaId,
                    userInput: captcha.value
                },

                props.url
            )

            if (!response.success) {
                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_100'),
                    life: 3000
                });
                return false;
            }
            else {
                return response.data;
            }

        }
        catch (ex) {
            toast.current.show({
                severity: 'error',
                detail: props.t('err_001_045_100'),
                life: 3000
            });
            return false;
        } finally {
            setIsLoading(false);
        };
    }

    const sendOtpMail = () => {
        setIsLoading(true);
        authenticationService.sendOtpMail(
            userId,
            props.url
        )
            .then(response => {
                if (!response.success) {

                    toast.current.show({
                        severity: 'error',
                        detail: props.t('err_001_045_100'),
                        life: 3000
                    });

                    return;
                }
                setOtp(null);
                setCount(250);
                setIsCounting(true);

            })
            .catch(ex => {
                console.error(ex);

                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_100'),
                    life: 3000
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
    const otpControl = () => {

        if (!otp || otp.length < 6) {
            toast.current.show({
                severity: 'info',
                detail: props.t('info_001_045_119'),
                life: 3000
            });
            return;
        }

        setIsLoading(true);

        authenticationService.otpControl(
            otp,
            userId,
            props.url
        )
            .then(response => {
                if (!response.success) {

                    toast.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 3000
                    });
                    setOtp(null);
                    return;
                }
                else {

                    setVisible(false);

                    if (props.onSuccess) {

                        if (response.data?.user?.isLdapLogin) {
                            props.onSuccess(response.data);
                        } else {

                            if (response.data?.user?.isFirstLogin == false) {
                                props.onSuccess(response.data);
                            } else {
                                const token = response.data?.token; // Backend'in döndüğü token
                                if (token) {
                                    window.location.href = `/reset-password?token=${(token)}`;
                                } else {
                                    console.error(props.t('err_001_045_118'));
                                }
                            }
                        }
                    }
                }

            })
            .catch(ex => {
                console.error(ex);

                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_100'),
                    life: 3000
                });
            })
            .finally(() => {
                setIsLoading(false);
            });
    }
    const sendResetPasswordLink = () => {

        if (!username.value) {

            toast.current.show({
                severity: 'info',
                detail: props.t('info_001_045_114'),
                life: 3000
            });

            return;
        }

        const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

        if (!isValidEmail.test(username.value)) {
            toast.current.show({
                severity: 'info',
                detail: props.t('info_001_045_115'),
                life: 3000
            });

            return;
        }

        setIsResetLoading(true);

        authenticationService.sendResetPasswordLink({ email: username.value }, props.url).
            then(response => {

                if (!response.success) {

                    toast.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 3000
                    });

                    return;
                }

                toast.current.show({
                    severity: 'success',
                    detail: props.t('info_001_045_101'),
                    life: 3000
                });

                setTimeout(() => {

                    changeForgetPassword(true);

                }, 3000);
            }).
            catch(ex => {

                toast.current.show({
                    severity: 'error',
                    detail: props.t('err_001_045_102'),
                    life: 3000
                });

            }).finally(() => {

                setIsResetLoading(false);
            })
    }

    return (
        <>
            <Toast ref={toast} />
            <div className="bs-login">
                {backgroundImage &&
                    <div className='item bs-img-side'>
                        <img src={backgroundImage} className="bs-img" />
                    </div>
                }
                <div className='item bs-login-side'>
                    <div className='bs-login-form'>
                        {forgetPassword ?
                            <>
                                {logo &&
                                    <img className='bs-logo' src={logo}></img>
                                }
                                {appName &&
                                    <h3 className='bs-app-name'>{appName}</h3>
                                }

                                <div className="card flex flex-column">
                                    {/* taraycıların otomatik doldurmasını engellemek için */}
                                    <input
                                        type="text"
                                        name="fake-username"
                                        autoComplete="username"
                                        style={{ position: 'absolute', top: '-9999px', left: '-9999px' }}
                                        tabIndex={-1}
                                    />
                                    <input
                                        type="password"
                                        style={{ position: 'absolute', top: '-9999px', left: '-9999px' }}
                                        tabIndex={-1}
                                        autoComplete="off"
                                    />
                                    {domainSelection ?
                                        <>
                                            <Dropdown
                                                value={selectedDomainName}
                                                onChange={(e) => setSelectedDomainName(e.value)}
                                                options={domainList}
                                                optionLabel="value"
                                                optionValue='value'
                                                showClear
                                                placeholder={props.t('lbl_001_045_120')}
                                                className="w-full mb-2 bs-domain-select" // Genişliği ayarlanabilir
                                                style={{ borderRadius: '6px', textAlign: 'justify' }}
                                            />
                                            <div className="p-inputgroup bs-inputgroup mb-2">
                                                <span className="p-inputgroup-addon">
                                                    <i className="pi pi-user"></i>
                                                </span>
                                                <InputText placeholder={identityNumber ? props.t('lbl_001_045_116') : props.t('lbl_001_045_117')}
                                                    autoFocus
                                                    value={username.value}
                                                    onChange={username.onChange}
                                                    onKeyDown={(e) => {

                                                        if (e.key === 'Enter') {

                                                            login();
                                                        }
                                                    }}
                                                    autoComplete='off'
                                                />
                                            </div>
                                        </> :
                                        <div className="p-inputgroup bs-inputgroup mb-2">
                                            <span className="p-inputgroup-addon">
                                                <i className="pi pi-user"></i>
                                            </span>
                                            <InputText placeholder={identityNumber ? props.t('lbl_001_045_116') : props.t('lbl_001_045_117')}
                                                autoFocus
                                                value={username.value}
                                                onChange={username.onChange}
                                                onKeyDown={(e) => {

                                                    if (e.key === 'Enter') {

                                                        login();
                                                    }
                                                }}
                                                autoComplete='off'
                                            />
                                        </div>
                                    }

                                    <div className="p-inputgroup bs-inputgroup mb-2">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-lock"></i>
                                        </span>
                                        <Password placeholder={props.t('lbl_001_045_103')}
                                            toggleMask
                                            feedback={false}
                                            type='password'
                                            value={password.value}
                                            onKeyDown={(e) => {

                                                if (e.key === 'Enter') {

                                                    login();
                                                }
                                            }}
                                            onChange={password.onChange}
                                        />
                                    </div>
                                </div>
                                {
                                    captchaControl || wrongPassword ?
                                        <div className='bs-captcha'>
                                            <div className='bs-captcha-img'>
                                                <img
                                                    id="bs-captcha-canvas"
                                                    alt="Captcha"
                                                />
                                                <Button className='bs-captcha-btn'
                                                    onClick={() => {
                                                        generateCaptcha();
                                                        captcha.onReset()
                                                    }}
                                                    icon="pi pi-refresh" />
                                            </div>
                                            <div className='bs-input'>
                                                <InputText value={captcha.value}
                                                    onKeyDown={(e) => {

                                                        if (e.key === 'Enter') {

                                                            login();
                                                        }
                                                    }}
                                                    onChange={captcha.onChange} />
                                            </div>
                                        </div>
                                        : null
                                }

                                {
                                    rememberMe || forgotPassword ?
                                        <div className='bs-remember-me'>
                                            {rememberMe ?
                                                <div className="flex align-items-center bs-switch-and-label">
                                                    <InputSwitch onChange={e => setIsRememberMe(e.value)} checked={isRememberMe}></InputSwitch>
                                                    <label htmlFor="ingredient4" className="ml-2"> {props.t('lbl_001_045_104')}</label>
                                                </div>
                                                : null
                                            }
                                            {forgotPassword ?
                                                <a className='bs-forget-password'
                                                    onClick={() => changeForgetPassword(false)}>{props.t('lbl_001_045_105')}
                                                </a>
                                                : null
                                            }
                                        </div>
                                        : null
                                }
                                <Button onClick={login}
                                    loading={isLoading}
                                    className='bs-login-btn'
                                    icon="pi pi-check"
                                    label={props.t('lbl_001_045_106')} />
                                {
                                    edevlet ?

                                        <div className='other-login-options'>
                                            <h2><span>Veya</span></h2>
                                            <Button className='edevlet' label={props.t('lbl_001_045_113')} iconPos="left">
                                                <img alt="logo" src="https://play-lh.googleusercontent.com/6cfkfK3VEs461QmIMdZHHwOeacOdsCMo-ig4P7pQ8CV3tWsVTQLL8pU0kyfdgcfZS8ck" className="h-2rem"></img>
                                            </Button>
                                        </div>
                                        : null
                                }
                                {register ?
                                    <a className='bs-register' href=''>{props.t('lbl_001_045_108')} <b>{props.t('lbl_001_045_107')}</b></a>
                                    : null
                                }
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }} className='mt-3'>

                                    <p style={{
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        margin: 0
                                    }}>
                                        {version}
                                    </p>

                                </div>
                                <Dropdown
                                    value={selectedLanguage}
                                    onChange={(e) => changeLanguage(e.value)}
                                    options={language}
                                    optionLabel="value"
                                    optionValue="key"
                                    valueTemplate={(option, props) => {
                                        if (option) {
                                            let flagSrc = "";
                                            if (option.key === "en") {
                                                flagSrc = "https://flagcdn.com/w40/gb.png";
                                            } else {
                                                flagSrc = "https://flagcdn.com/w40/" + option.key + ".png";
                                            }
                                            return (
                                                <div className="flex align-items-center">
                                                    <img
                                                        alt={option.value}
                                                        src={flagSrc}
                                                        style={{ width: "24px" }}
                                                    />
                                                    <div className='ml-2'>{option.value}</div>
                                                </div>
                                            );
                                        }
                                    }}
                                    itemTemplate={(option) => {
                                        let flagSrc = "";
                                        if (option.key === "en") {
                                            flagSrc = "https://flagcdn.com/w40/gb.png";
                                        } else {
                                            flagSrc = "https://flagcdn.com/w40/" + option.key + ".png";
                                        }
                                        return (
                                            <div className="flex align-items-center">
                                                <img
                                                    alt={option.value}
                                                    src={flagSrc}
                                                    style={{ width: "24px" }}
                                                    className={`mr-2 flag flag-${option.key.toLowerCase()}`}
                                                />
                                                <div>{option.value}</div>
                                            </div>
                                        );

                                    }}
                                    className="mt-3"
                                    style={{ borderRadius: "6px", border: "none", backgroundColor: "transparent" }}
                                    pt={{
                                        trigger: { style: { display: 'none' } } // oku gizler
                                    }}

                                />
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }}>
                                </div>
                            </>
                            :
                            <div className='bs-forget-password-area'>
                                <i className="pi pi-lock"></i>
                                <h1>{props.t('lbl_001_045_109')}</h1>
                                <h4>{props.t('lbl_001_045_110')}</h4>
                                <div className="card flex flex-column">
                                    <div className="p-inputgroup bs-inputgroup">
                                        <span className="p-inputgroup-addon">
                                            <i className="pi pi-user"></i>
                                        </span>
                                        <InputText placeholder={props.t('lbl_001_045_099')}
                                            value={username.value}
                                            autoFocus
                                            onChange={username.onChange}
                                            onKeyDown={(e) => {

                                                if (e.key === 'Enter') {

                                                    sendResetPasswordLink();
                                                }
                                            }}
                                        />
                                    </div>
                                    <Button loading={isResetLoading}
                                        className='bs-btn'
                                        onClick={() => sendResetPasswordLink()}
                                        label={props.t('lbl_001_045_111')}
                                        icon="pi pi-send" />
                                    <p onClick={() => changeForgetPassword(true)}>
                                        {props.t('lbl_001_045_112')}
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                </div >
            </div >
            <Dialog
                visible={visible}
                modal
                onHide={() => { if (!visible) return; setVisible(false); }}
                content={({ hide }) => (
                    <div className="flex flex-column px-8 py-5 gap-3 bs-login-otp" >
                        <h2>{props.t('info_001_045_121')}</h2>

                        <div className="inline-flex flex-column gap-2">
                            <InputOtp value={otp} length={6} onChange={(e) => setOtp(e.value)} integerOnly mask />
                        </div>
                        <p>{props.t('info_001_045_122') + count + props.t('info_001_045_123')}</p>
                        <Button loading={isLoading} style={{ textDecoration: "underline" }} label="Şifreyi Tekrar Yolla" onClick={sendOtpMail} text />
                        <div header="Header" className="flex align-items-right gap-2">
                            <Button disabled={count < 1} loading={isLoading} label={props.t('lbl_001_045_124')} onClick={otpControl} ></Button>
                            <Button label={props.t('lbl_001_045_125')} onClick={(e) => hide(e)} ></Button>
                        </div>
                    </div>
                )}
            ></Dialog>
        </>
    );
}

export default Login;
